( function( app ) {
  const COMPONENT = {
    init: function() {
      const section = document.querySelector( '[data-component="video-logo-hero"]' );
      if ( !section ) return;

      const btn = section.querySelector( '.js-scroll-down' );
      if ( !btn ) return;

      btn.addEventListener( 'click', function() {
        window.scrollTo( {
          top: section.offsetTop + section.offsetHeight,
          behavior: window.hasMotion ? 'smooth' : 'auto',
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'video-logo-hero', COMPONENT );
} )( app );
